<div class="receivables-balance-details-view-container"  fxLayout="column" fxLayoutGap="15px" >
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Saldo</h3>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Saldo bieżące" >
                  {{(receivablesBalanceObject?.sumDeposits !== null ? receivablesBalanceObject.sumDeposits - receivablesBalanceObject.sumPolicy : 0) | number:'1.2-2'}} zł
                </app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Numer Salda/Tytuł przelewu"  [value]="receivablesBalanceObject?.recordId">
                </app-detail>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Ostatnie notatki</h3>
            </div>
            <div  *ngFor="let note of receivablesBalanceObject?.receivablesBalanceNotesLast">

              <div fxFlex="100" fxLayout="row">
                <app-detail fxFlex="100" header="{{note.createdAt  | date:'y-MM-dd HH:mm' }} {{note.createdBy.firstName}}  {{note.createdBy.lastName}}"  [value]="note?.note"></app-detail>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%"  *ngIf="logs.length > 0">
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Przypomnienia</h3>
            </div>
            <div fxLayout="column">
              <ng-container *ngFor="let element of logs">
                <ng-container *ngFor="let items of element.items; let i = index">
                  <ng-container >
                    <div fxLayout="row" fxLayoutGap="15px">
                      <span class="log-counter" fxFlex="5">{{i+1}}.</span>
                      <app-detail fxFlex="45" *ngIf="items.log?.createdAt" header="Data wysłania">
                        {{items.log?.createdAt | date:'y-MM-dd HH:mm:ss'}}
                      </app-detail>
                      <app-detail fxFlex="50" *ngIf="items?.log.user" header="Użytkownik">
                        <a class="default-link" [routerLink]="['/uzytkownicy/szczegoly', items.log.user.uuid]">{{items.log.user.firstName}} {{items.log.user.lastName}}</a>
                      </app-detail>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
            </div>

          </mat-card>
        </div>
      </div>

    </div>

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px" >
      <div fxLayout="row" fxFlex.lt-md="100%"  *ngIf="receivablesBalanceObject?.partner">
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Dane salda Partner</h3>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Nazwa skrócona Partnera" [value]="receivablesBalanceObject.partner?.shortName" [link]="['/partnerzy/szczegoly', receivablesBalanceObject.partner.uuid]"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px"  >
              <div fxFlex="100" >
                <app-detail header="Regionalny Partnera"  [value]="receivablesBalanceObject.partner?.assetsRegional?.fullName">
                </app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf=" receivablesBalanceObject.partner?.emails && (receivablesBalanceObject.partner?.emails | billingContact)?.length === 0">
              <div fxFlex="100">
                <h5 class="small-margin-header">
                  Adres email rozliczeniowy
                </h5>
                <ng-container *ngFor="let email of receivablesBalanceObject.partner.emails | primaryContact; let last = last">
                  <div fxLayout="row" fxLayoutGap="15px">
                    <app-detail fxFlex="50" header="Adres" [value]="email.address"></app-detail>
                    <app-detail fxFlex="50" header="Nazwa" [value]="email?.name"></app-detail>
                  </div>
                </ng-container>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf="receivablesBalanceObject.partner?.emails && (receivablesBalanceObject.partner?.emails | billingContact)?.length > 0">
              <div fxFlex="100">
                <h5 class="small-margin-header">Adres email rozliczeniowy</h5>
                <ng-container *ngFor="let email of receivablesBalanceObject.partner.emails | billingContact; let last = last">
                  <div fxLayout="row" fxLayoutGap="15px">
                    <app-detail fxFlex="50" header="Adres" [value]="email.address"></app-detail>
                    <app-detail fxFlex="50" header="Nazwa" [value]="email?.name"></app-detail>
                  </div>
                </ng-container>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf="receivablesBalanceObject.partner?.phones && (receivablesBalanceObject.partner?.phones | billingContact)?.length === 0">
              <div fxFlex="100">
                <h5 class="small-margin-header">
                  Numer telefonu rozliczeniowy</h5>
                <ng-container *ngFor="let phone of receivablesBalanceObject.partner?.phones | primaryContact; let last = last">
                  <div fxLayout="row" fxLayoutGap="15px">
                    <app-detail fxFlex="50" header="Numer" [value]="phone.number | phone"></app-detail>
                    <app-detail fxFlex="50" header="Nazwa" [value]="phone?.name"></app-detail>
                  </div>
                </ng-container>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf="receivablesBalanceObject.partner?.phones && (receivablesBalanceObject.partner?.phones | billingContact)?.length > 0">
              <div fxFlex="100">
                <h5 class="small-margin-header">Numer telefonu rozliczeniowy</h5>
                <ng-container *ngFor="let phone of receivablesBalanceObject.partner.phones | billingContact; let last = last">
                  <div fxLayout="row" fxLayoutGap="15px">
                    <app-detail fxFlex="50" header="Numer" [value]="phone.number | phone"></app-detail>
                    <app-detail fxFlex="50" header="Nazwa" [value]="phone.name ? phone.name : ''"></app-detail>
                  </div>
                </ng-container>
              </div>
            </div>

          </mat-card>
        </div>
      </div>
        <div fxLayout="row" fxFlex.lt-md="100%"  *ngIf="receivablesBalanceObject?.ofwca">
          <div fxFlex="100">
            <mat-card class="partners-add-card">
              <div fxLayout="row">
                <h3>Dane salda OFWCA</h3>
              </div>
              <div fxLayout="row" fxLayoutGap="15px">
                <div fxFlex="100">
                  <app-detail header="OFWCA" [value]="receivablesBalanceObject.ofwca?.fullName" [link]="['/ofwca/szczegoly', receivablesBalanceObject.ofwca.uuid]"></app-detail>
                </div>
              </div>

              <div fxLayout="row" fxLayoutGap="15px" *ngIf="receivablesBalanceObject.partnerFacility">
                <div fxFlex="100">
                  <app-detail header="Placówka" [value]="receivablesBalanceObject.partnerFacility?.address?.searchString"  [link]="receivablesBalanceObject.partnerFacility ? ['/placowki/szczegoly', receivablesBalanceObject.partnerFacility?.address?.uuid] : undefined"></app-detail>
                </div>
              </div>

              <div fxLayout="row" fxLayoutGap="15px"  >
                <div fxFlex="100" >
                  <app-detail header="Regionalny OFWCA"  [value]="receivablesBalanceObject.ofwca?.assetsRegional?.fullName">
                  </app-detail>
                </div>
              </div>

              <div fxLayout="row" fxLayoutGap="15px"  >
                <div fxFlex="100" >
                  <app-detail header="Adres email"  [value]="(receivablesBalanceObject.ofwca?.emails | mainContact)[0]?.address">
                  </app-detail>
                </div>
              </div>


              <div fxLayout="row" fxLayoutGap="15px"  >
                <div fxFlex="100" >
                  <app-detail header="Numer telefonu"  [value]="receivablesBalanceObject.ofwca?.phone">
                  </app-detail>
                </div>
              </div>

            </mat-card>
          </div>
        </div>


    </div>

  </div>
</div>
